import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router";
import { BOOKING, ROADS } from "../../config/constants/api";
import { Button, Col, Steps, Row, Card, Modal, Input, Spin } from "antd";
import { AiFillEnvironment } from "react-icons/ai";
import DashbordSidebar from "../../components/DashboardSidebar";
import { FaArrowLeftLong } from "react-icons/fa6";
import { extractDate, extractTime } from "../../config/helpers";
import swal from "sweetalert";
import { IoChatbubbleEllipses } from "react-icons/io5";
import { Put } from "../../config/api/put";
import {
  setStartTime,
  addPathPoint,
  resetPath,
  setTotalDistance,
  resetRideState,
  setRidingState,
} from "../../redux/slice/rideSlice";
import ChatComponent from "../../components/ChatComponent";
import ReviewModal from "../../components/ReviewModal";
import socket from "../../config/socket";
import { Get, Post } from "../../config/api";
import MapComponent from "../../components/MapComponent";
import { useDispatch, useSelector } from "react-redux";


const { Step } = Steps;
const RideDetails = () => {
  let recordedCoordinates = [];
  // const watchId = useRef(null);
  const dispatch = useDispatch();
  // const trackingInterval = useRef(null);
  const navigate = useNavigate();
  const token = useSelector((state) => state.user.userToken);
  const startTime = useSelector((state) => state.ride.startTime);
  const totalDistance = useSelector((state) => state.ride.totalDistance);
  const isRiding = useSelector((state) => state.ride.riding);
  // const pathPoints = useSelector((state) => state.ride.path);
  const location = useLocation();
  const [data, setData] = useState(null);
  const id = location.state?.id;
  const [pickupLocation, setPickupLocation] = useState({
    coordinates: [0, 0],
  });
  const [modal2Open, setModal2Open] = useState(false);
  const [status, setStatus] = useState("");
  const [isChatVisible, setIsChatVisible] = useState(false);
  // const [totalDuration, setTotalDuration] = useState(0);
  const [tolls, setTolls] = useState(0);
  // const [surcharge, setSurcharge] = useState(0);
  const [driverPosition, setDriverPosition] = useState(null);
  const locationInterval = useRef(null);
  const backendInterval = useRef(null);
  // const coordinateIndex = useRef(0);
  const updateDriverLocation = (location) => {
    setDriverPosition(location);
  };

  // const dummyLocations = [
  //   {
  //     longitude: 67.07475701861792,
  //     latitude: 24.892118358155273,
  //   },
  //   {
  //     longitude: 67.08151436996225,
  //     latitude: 24.89619239171547,
  //   },
  //   {
  //     longitude: 67.08815288159879,
  //     latitude: 24.893412998402155,
  //   },
  //   {
  //     longitude: 67.07441795276226,
  //     latitude: 24.885680321307976,
  //   },
  //   {
  //     longitude: 67.07856162392589,
  //     latitude: 24.887206189186262,
  //   },
  // ];
  // const dummyCoordinates = [
  //   { latitude: "24.874464653931405", longitude: "67.0670588790336" },
  //   { latitude: "24.87303553317452", longitude: "67.06895390308317" },
  //   { latitude: "24.875563499473614", longitude: "67.07085209331235" },
  //   { latitude: "24.87603070428819", longitude: "67.07099156818035" },
  //   { latitude: "24.876653641293178", longitude: "67.0715923829963" },
  //   { latitude: "24.878687898111956", longitude: "67.07307296236831" },
  //   { latitude: "24.881296369842214", longitude: "67.07430677851654" },
  //   { latitude: "24.883651733490147", longitude: "67.07483249148049" },
  //   { latitude: "24.885432825832098", longitude: "67.07411365946855" },
  //   { latitude: "24.887301485243707", longitude: "67.07318025073727" },
  //   { latitude: "24.888917074201064", longitude: "67.07225757084134" },
  //   { latitude: "24.890221208906883", longitude: "67.07189279041737" },
  //   { latitude: "24.8901913907418", longitude: "67.07045763728111" },
  //   { latitude: "24.890327642859795", longitude: "67.07081168886909" },
  //   { latitude: "24.89058068210866", longitude: "67.0729252695609" },
  //   { latitude: "24.890862041655677", longitude: "67.07524065563254" },
  // ];

  // useEffect(() => {
  //   if (status !== "COMPLETED") {
  //     if (pathPoints.length >= 2) {
  //       sendPathToBackend(pathPoints); // pass current path directly
  //     }
  //   }
  // }, [pathPoints.length]);

  // const getAccurateDistance = async (origin, destination) => {
  //   console.log(origin, destination);
  //   console.log("get accurate distance");

  //   if (!window.google || !window.google.maps) {
  //     console.log("Google Maps API is not loaded.");
  //     message.error("Google Maps API is not loaded. Please try again later.");
  //     return { distance: 0, durationText: "0 mins" };
  //   }

  //   const pickupCoordinates = {
  //     lat: origin?.lat,
  //     lng: origin?.lng,
  //   };
  //   const dropoffCoordinates = {
  //     lat: destination?.lat,
  //     lng: destination?.lng,
  //   };

  //   const distanceMatrixService =
  //     new window.google.maps.DistanceMatrixService();

  //   return new Promise((resolve, reject) => {
  //     distanceMatrixService.getDistanceMatrix(
  //       {
  //         origins: [pickupCoordinates],
  //         destinations: [dropoffCoordinates],
  //         travelMode: window.google.maps.TravelMode.DRIVING,
  //       },
  //       (response, status) => {
  //         if (status === window.google.maps.DistanceMatrixStatus.OK) {
  //           const distanceData = response?.rows[0]?.elements[0];

  //           if (distanceData) {
  //             const distanceText = distanceData?.distance?.text;
  //             const durationText = distanceData?.duration?.text;
  //             let distanceInKm = 0;
  //             if (distanceText.includes("km")) {
  //               distanceInKm = parseFloat(distanceText.replace(" km", ""));
  //             } else if (distanceText.includes("m")) {
  //               const meters = parseFloat(distanceText.replace(" m", ""));
  //               distanceInKm = meters / 1000; // 1 km = 1000 meters
  //             } else if (distanceText.includes("mi")) {
  //               const miles = parseFloat(distanceText.replace(" mi", ""));
  //               distanceInKm = miles * 1.60934; // 1 mile = 1.60934 km
  //             } else {
  //               console.warn("Unexpected distance unit in:", distanceText);
  //             }
  //             resolve({
  //               distance: parseFloat(distanceInKm.toFixed(3)),
  //               durationText,
  //             });
  //           } else {
  //             console.log("Distance data is missing in the response.");
  //             message.error("Distance data is missing in the response.");
  //             resolve({ distance: 0, durationText: "0 mins" });
  //           }
  //         } else {
  //           console.log(`Error fetching distance matrix: ${status}`);
  //           message.error(
  //             `Error fetching distance matrix: ${status}. Please try again.`
  //           );
  //           resolve({ distance: 0, durationText: "0 mins" });
  //         }
  //       }
  //     );
  //   });
  // };

  // const startTrackingDistanceAndTime = () => {
  //   dispatch(resetRideState());
  //   dispatch(setStartTime(new Date()));
  //   trackingInterval.current = setInterval(async () => {
  //     navigator.geolocation.getCurrentPosition(
  //       async (position) => {
  //         const { latitude, longitude } = position.coords;
  //         const currentLocation = { lat: latitude, lng: longitude };
  //         // const currentLocation = {
  //         //   lat: dummyLocations[
  //         //     Math.floor(Math.random() * dummyLocations.length)
  //         //   ].latitude,
  //         //   lng: dummyLocations[
  //         //     Math.floor(Math.random() * dummyLocations.length)
  //         //   ].longitude,
  //         // };

  //         // Set initial point
  //         if (!lastLocation.current) {
  //           console.log("1");
  //           lastLocation.current = currentLocation;
  //           return;
  //         }

  //         // Calculate distance using Distance Matrix API
  //         const result = await getAccurateDistance(
  //           lastLocation.current,
  //           currentLocation
  //         );
  //         console.log("Distance Result:", result);
  //         if (result) {
  //           totalDistanceCovered.current += result?.distance;
  //           dispatch(setTotalDistance(totalDistanceCovered.current));
  //         }

  //         lastLocation.current = currentLocation; // update for next interval
  //       },
  //       (error) => console.error("Error getting geolocation:", error),
  //       { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
  //     );
  //   }, 15000); // every 15 seconds
  // };
  const updateInterval = 3000;
  useEffect(() => {
    if (status === "ONGOING" || status === "ARRIVED") {
      const sendDriverLocation = () => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((position) => {
            const location = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            };
            updateDriverLocation(location);
            socket.emit("updateMyLocation", {
              userId: data?.user?._id,
              coordinates: [location.longitude, location.latitude],
              // send coordinates from dummyLocations
              // coordinates: [
              //   dummyLocations[
              //     Math.floor(Math.random() * dummyLocations.length)
              //   ].longitude,
              //   dummyLocations[
              //     Math.floor(Math.random() * dummyLocations.length)
              //   ].latitude,
              // ],
            });
          });
        }
      };

      const intervalId = setInterval(sendDriverLocation, updateInterval);

      return () => clearInterval(intervalId);
    }
    // eslint-disable-next-line
  }, [status, updateDriverLocation]);

  const startTrackingDistanceAndTime = () => {
    dispatch(resetRideState());
    dispatch(setStartTime(new Date()));
    recordedCoordinates = [];

    // Start location fetch every 5 seconds
    locationInterval.current = setInterval(() => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          // if (coordinateIndex.current >= dummyCoordinates.length) {
          //   clearInterval(locationInterval.current);
          //   clearInterval(backendInterval.current);
          //   recordedCoordinates = [];
          //   // dispatch(resetRideState());
          //   completeBooking(); // Call completion function
          //   return;
          // }
          const currentLocation = {
            latitude: latitude,
            longitude: longitude,
          };
          const newPoint = {
            lat: currentLocation.latitude,
            lng: currentLocation.longitude,
          };
          // coordinateIndex.current += 1;
          dispatch(addPathPoint(newPoint));
          recordedCoordinates.push(newPoint);
          console.log("New coordinate:", newPoint);
        },
        (error) => console.error("Error getting position:", error),
        { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
      );
    }, 3000);

    // Start backend sync every 30 seconds
    backendInterval.current = setInterval(() => {
      if (recordedCoordinates.length < 2) return;
      sendPathToBackend();
    }, 30000);
  };

  const sendPathToBackend = async () => {
    try {
      // console.log(recordedCoordinates, "recordedCoordinates-in send to path");
      const response = await Post(
        ROADS.snapToRoads,
        { path: recordedCoordinates },
        token
      );
      if (response?.status) {
        const distance = response?.data;
        // console.log(distance, "distance from backend");
        dispatch(setTotalDistance(distance));
        // console.log(distance, "totalDistance now");
        recordedCoordinates = [];
        // dispatch(resetPath()); // Clear path after sending
      }
    } catch (err) {
      console.error("Error in sending path to backend", err);
    }
  };

  const stopTrackingDistanceAndTime = async () => {
    if (locationInterval.current) {
      clearInterval(locationInterval.current);
      locationInterval.current = null;
    }
    if (backendInterval.current) {
      clearInterval(backendInterval.current);
      backendInterval.current = null;
    }
    if (recordedCoordinates.length >= 2) {
      await sendPathToBackend(); // ensure last part is not skipped
    }
    const endTime = new Date();
    const durationMs = endTime - startTime;

    const durationHours = durationMs / (1000 * 60 * 60);
    // const durationMinutes = durationMs / (1000 * 60);
    recordedCoordinates = [];
    dispatch(resetPath());
    // return durationHours;
    return isNaN(durationHours) || durationHours < 0 ? 0 : durationHours;
  };
  const getBookingDetails = async () => {
    Get(BOOKING.getbooking + id, token)
      .then((response) => {
        if (response?.status) {
          setData(response?.data?.booking);
          setStatus(response?.data?.booking?.status);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };
  useEffect(() => {
    if (!id) {
      navigate(-1);
    } else {
      getBookingDetails();
    }
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (
      pickupLocation.coordinates[0] === 0 &&
      pickupLocation.coordinates[1] === 0
    ) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        setPickupLocation({
          coordinates: [longitude, latitude],
        });
      });
    }
    // eslint-disable-next-line
  }, []);

  const completeBooking = () => {
    setModal2Open(true);
  };
  const handleSubmit = async () => {
    // Validate tolls
    const tollsValue = tolls === "" || tolls === null || tolls === undefined ? 0 : parseFloat(tolls);
    
    if (isNaN(tollsValue) || tollsValue < 0) {
      swal("Validation Error", "Please enter valid tolls charges (must be 0 or greater)", "error");
      return;
    }

    // Stop tracking and get calculated duration
    const durationHours = await stopTrackingDistanceAndTime();
    
    // Calculate final mileage from system (convert km to miles)
    const calculatedMileage = totalDistance * 0.621371;
    
    // Use system-calculated values
    handleStatus("COMPLETED", durationHours, calculatedMileage, tollsValue);
    setModal2Open(false);
    
    // Reset form values
    setTolls(0);
  };
  const [showReviewModal, setShowReviewModal] = useState(false);
  const handleOkReviewModal = () => {
    setShowReviewModal(false);
    navigate("/ride", { state: { index: 2 } });
  };

  const handleStatus = async (status, durationHours, mileage, tollsValue) => {
    let body = {
      status,
    };
    if (status === "COMPLETED") {
      // Use provided values (required fields)
      body.finalMileage = mileage !== undefined ? mileage : 0;
      body.finalDuration = durationHours !== undefined ? durationHours : 0;
      body.tolls = tollsValue !== undefined ? tollsValue : 0;
    }
    Put(`${BOOKING.changeBookingStatus}${data._id}`, token, body)
      .then((response) => {
        if (response?.status) {
          swal("System Alert", response?.message, "success");
          setStatus(response?.data?.status);
          if (response?.data?.status === "ONGOING") {
            if (!isRiding) {
              dispatch(setRidingState(true));
            }
            // setIsMapVisible(true);
          } else if (response?.data?.status === "COMPLETED") {
            dispatch(resetRideState());
            if (isRiding) {
              dispatch(setRidingState(false));
            }
            // stopTrackingDistanceAndTime();
            setShowReviewModal(true);
          } else if (response?.data?.status === "ARRIVED") {
            startTrackingDistanceAndTime();
          }
        }
      })
      .catch((err) => {
        let message = err?.response?.data?.message || err?.message;
        console.log(":::;", err);
        if (message) swal("Oops!", message, "error");
      });
  };

  const toggleChat = () => {
    setIsChatVisible(!isChatVisible);
  };
  // function formatDuration(totalDuration) {
  //   if (totalDuration) {
  //     const totalMinutes = Math.round(totalDuration * 60);
  //     const hours = Math.floor(totalMinutes / 60);
  //     const minutes = totalMinutes % 60;
  //     if (hours === 0) {
  //       return `${minutes} mins`;
  //     } else if (minutes === 0) {
  //       return `${hours} hour${hours > 1 ? "s" : ""}`;
  //     } else {
  //       return `${hours} hour${hours > 1 ? "s" : ""} ${minutes} mins`;
  //     }
  //   } else {
  //     return 0;
  //   }
  // }
  return (
    <>
      <div className="shop-page">
        <Row style={{ width: "100%", justifyContent: "center" }}>
          <Col xs={23} md={21}>
            <div className="shop-page-main">
              <Row gutter={[16, 16]}>
                <Col xs={24} md={24} lg={24} xl={24}>
                  <div className="my-account-profile">
                    <section className="side-menu-parent">
                      <DashbordSidebar />
                      <div
                        className="about-us-section"
                        style={{
                          justifyContent: "center",
                          position: "relative",
                        }}
                      >
                        {data ? (
                          <div className="bg-paren" style={{ width: "100%" }}>
                            <Card
                              className="orderDetails"
                              // style={{ padding: "20px 0" }}
                            >
                              {/* <Row
                                style={{
                                  width: "100%",
                                  justifyContent: "center",
                                }}
                              >
                                <Col lg={24} xs={24}>
                                  <div class="arrow-box">
                                    <FaArrowLeftLong
                                      className="arrow"
                                      onClick={() => navigate(-1)}
                                    />
                                  </div>
                                </Col>
                              </Row> */}

                              <Row gutter={[16, 16]}>
                                <Col
                                  lg={24}
                                  md={24}
                                  xs={24}
                                  style={{
                                    textAlign: "end",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <Row gutter={[16, 16]} justify={"center"}>
                                    <div
                                      id="map"
                                      style={{
                                        // height: "350px",
                                        width: "100%",
                                        zIndex: "1",
                                        position: "relative",
                                      }}
                                    >
                                      <Col
                                        lg={24}
                                        md={24}
                                        xs={24}
                                        style={{
                                          textAlign: "end",
                                          zIndex: 999,
                                          position: "relative",
                                        }}
                                      >
                                        <div className="pet-name-pic" style={{alignItems:'start',justifyContent:'space-between'}}>
                                        <div class="arrow-box">
                                    <FaArrowLeftLong
                                      className="arrow"
                                      onClick={() => navigate(-1)}
                                    />
                                  </div>
                                          <div>
                                            <Button
                                              onClick={toggleChat}
                                              className="web-btn"
                                            >
                                              message <IoChatbubbleEllipses />
                                            </Button>
                                            {/* <IoChatbubbleEllipses onClick={toggleChat} className="chat-icon"/> */}
                                            {/* <h6 className="f-16-black">
                                              Initial Charged Amount: $
                                              {data?.initialCharges}
                                            </h6> */}
                                            <p className="web-p" style={{margin:'0px'}}>
                                              Date: {extractDate(data?.date)}
                                            </p>
                                            <p className="web-p" style={{margin:'0px' , padding:'0px'}}>
                                              Time: {extractTime(data?.time)}
                                            </p>
                                          </div>
                                        </div>
                                      </Col>
                                      <Col
                                        lg={24}
                                        md={24}
                                        xs={24}
                                        style={{
                                          textAlign: "center",
                                          zIndex: 999,
                                          position: "relative",
                                        }}
                                      >
                                        {/* <Image
                                          src={
                                            data?.user?.image
                                              ? UPLOADS_URL + data?.user?.image
                                              : ImageUrl("avatar.png")
                                          }
                                          alt=""
                                          className="img-fluid"
                                          style={{
                                            width: "180px",
                                            height: "180px",
                                            borderRadius: "100px",
                                            objectFit: "cover",
                                            objectPosition: "center",
                                          }}
                                          preview={false}
                                        /> */}
                                        {data?.user?.firstName && (
                                          <h5>
                                            {" "}
                                            {data?.user?.firstName +
                                              " " +
                                              data?.user?.lastName}
                                          </h5>
                                        )}
                                        {/* <h5>John Doe</h5> */}
                                      </Col>
                                    </div>
                                    <Col lg={18} md={20} xs={24}>
                                      <div>
                                        {!(
                                          status === "ONGOING" ||
                                          status === "ARRIVED"
                                        ) ? (
                                          <Steps
                                            direction="vertical"
                                            size="small"
                                            current={0}
                                            className="mb-1"
                                            style={{
                                              // padding: "18px 0",
                                              backgroundColor: "#e7e7e7",
                                              borderRadius: "20px",
                                              padding: "40px",
                                              marginBottom: "20px",
                                            }}
                                          >
                                            <Step
                                              title="Pickup Location"
                                              icon={
                                                <AiFillEnvironment
                                                  style={{ color: "#bd8230" }}
                                                />
                                              }
                                              description={
                                                data?.pickupLocation?.address
                                              }
                                            />
                                            <Step
                                              title="Destination"
                                              icon={<AiFillEnvironment />}
                                              description={
                                                data?.dropoffLocation?.address
                                                  ? data?.dropoffLocation
                                                      ?.address
                                                  : "Unknown"
                                              }
                                            />
                                          </Steps>
                                        ) : (
                                          <>
                                            {driverPosition && (
                                              <MapComponent
                                                booking={data}
                                                status={status}
                                                driverPosition={driverPosition}
                                              />
                                            )}
                                          </>
                                        )}

                                        <div
                                          className="start-booking-btn-grop"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "10px",
                                            marginTop: "10px",
                                          }}
                                        >
                                          <p>
                                            Total Miles :{" "}
                                            {(totalDistance * 0.621371).toFixed(
                                              2
                                            )}
                                          </p>
                                          {/* <p>
                                            Total Time :{" "}
                                            {formatDuration(totalDuration)}
                                          </p> */}
                                          {status === "UPCOMING" ? (
                                            <Button
                                              className="web-btn"
                                              onClick={() => {
                                                handleStatus("ONGOING");
                                              }}
                                            >
                                              Start Booking
                                            </Button>
                                          ) : status === "ONGOING" ? (
                                            <Button
                                              className="web-btn"
                                              onClick={() => {
                                                handleStatus("ARRIVED");
                                              }}
                                            >
                                              Arrive
                                            </Button>
                                          ) : status === "ARRIVED" ? (
                                            <Button
                                              className="web-btn"
                                              onClick={completeBooking}
                                            >
                                              Completed
                                            </Button>
                                          ) : null}
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </Card>
                          </div>
                        ) : (
                          <div>
                            <Spin />
                          </div>
                        )}

                        {isChatVisible && (
                          <ChatComponent
                            data={data}
                            setIsChatVisible={setIsChatVisible}
                            isChatVisible={isChatVisible}
                          />
                        )}
                      </div>
                    </section>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>

      <Modal
        title="Complete Booking - Add Following Details"
        centered
        open={modal2Open}
        onOk={handleSubmit}
        onCancel={() => {
          setModal2Open(false);
          setTolls(0);
        }}
        className="web-modal"
        okText="Complete Booking"
      >
        <div style={{ marginBottom: "15px" }}>
          <label style={{ display: "block", marginBottom: "5px", fontWeight: "500" }}>
            Tolls Charges ($) <span style={{ color: "red" }}>*</span>
          </label>
          <Input
            placeholder="$0"
            value={tolls}
            style={{ margin: "5px 0" }}
            onChange={(e) => {
              setTolls(e.target.value);
            }}
            type="number"
            step="0.01"
            min="0"
          />
          <small style={{ color: "#666", fontSize: "12px" }}>
            Tolls charges (can be 0)
          </small>
        </div>
      </Modal>
      <ReviewModal
        open={showReviewModal}
        handleOk={handleOkReviewModal}
        handleCancel={handleOkReviewModal}
        firstName={data?.user?.firstName}
        lastName={data?.user?.lastName}
        user={data?.user?._id}
        // text="How was Your Experience"
      />
    </>
  );
};

export default RideDetails;
